"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pullValue = void 0;
var pullValue = function (option, value) {
    if (Array.isArray(value)) {
        return Array.from(value).filter(function (currentValue) { return currentValue !== option.value; });
    }
    return undefined;
};
exports.pullValue = pullValue;
//# sourceMappingURL=pullValue.js.map